import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { DATA_PRIVACY_HOME } from '../constants/constants'

const interestMarketingConfig = [
  {
    sectionName: <Message id="interestMarketing.interestTitle" />,
    isEnabled: true,
    enabledCountries: [],
    hasElmoTreatment: true,
    subSections: [
      {
        title: <Message id="interestMarketing.marketingPayPal.title" />,
        desc: <Message id="interestMarketing.marketingPayPal.desc" />,
        iconName: 'logo-paypal',
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: true,
        navigateTo: '/myaccount/privacy/settings/personalization/paypal',
        fptiClickData: {
          pgrp: DATA_PRIVACY_HOME,
          page: DATA_PRIVACY_HOME,
          link: 'marketing_on_pp',
        },
      },
      {
        title: <Message id="interestMarketing.marketingAccount.title" />,
        desc: <Message id="interestMarketing.marketingAccount.desc" />,
        iconName: 'desktop',
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: true,
        navigateTo: '/myaccount/privacy/settings/personalization/other',
        fptiClickData: {
          pgrp: DATA_PRIVACY_HOME,
          page: DATA_PRIVACY_HOME,
          link: 'marketing_on_others',
        },
      },
    ],
  },
]

export default interestMarketingConfig
